import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, ROLE_LABEL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Panel } from "@/components/common";
import { TextField } from "@/components/Crud";

export function ChangePasswordCard() {
  const [f, setF] = useState({ old_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("Konfirmasi password tidak sama");
    setBusy(true);
    try {
      await api.put("/auth/password", { old_password: f.old_password, new_password: f.new_password });
      toast.success("Password berhasil diubah");
      setF({ old_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Panel className="h-fit p-6">
      <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
        <h3 className="text-lg font-semibold">Ubah Password Saya</h3>
        <TextField label="Password lama" testId="old-password-input" type="password" required value={f.old_password} onChange={(e) => setF({ ...f, old_password: e.target.value })} />
        <TextField label="Password baru" testId="new-password-input" type="password" minLength={6} required value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
        <TextField label="Ulangi password baru" testId="confirm-password-input" type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
        <Button data-testid="change-password-btn" type="submit" disabled={busy} className="w-full bg-orange-600 hover:bg-orange-700">Simpan Password</Button>
      </form>
    </Panel>
  );
}

export default function Profile() {
  const { user } = useAuth();
  return (
    <div>
      <PageHeader title="Akun Saya" subtitle={`${user.name} · ${ROLE_LABEL[user.role]} · ${user.email}`} />
      <div className="max-w-md"><ChangePasswordCard /></div>
    </div>
  );
}
